module.exports = __webpack_public_path__ + "23e9b654e0298d8270e592ce686daaa0.png";